import React, { useState, useEffect }  from "react"
import PropTypes from "prop-types"
import {bem} from "../../helpers"
import { DndProvider} from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { isMobile } from 'react-device-detect'
import "./List.scss"
import { DragItem } from "../Dnd/DragItem";

/**
 * Iterates over an Object or Array of data and renders list items
 * @typedef {object} props
 * @prop {boolean} bordered Adds border class
 * @prop {boolean} rounded Adds rounded class
 * @prop {boolean} shadowed Adds shadowed class
 * @prop {string} deliminated A string to seperate each value in data. Good for making comma or pipe seperated strings or links
 * @prop {boolean} bleed Adds bleed class
 * @prop {string} listType Choose between list-style-type css property values
 * @prop {object|array} data Data to iterate over. Calls render(index, value) for each item in Array or render(key, value) for each key in Object
 * @prop {boolean} ordered true will render an <ol /> as the root, false will render a <ul /> as the root
 * @extends {React.Component<props>} 
 */
export const List = (props) => {

  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(props.data)
  },
  [props.data]);

  const p = {
    listtype: props.listType,
    deliminated: props.deliminated,
    className: bem("list", "", [
      props.bordered && "bordered",
      props.rounded && "rounded",
      props.shadowed && "shadowed",
      props.deliminated && "deliminated",
      props.bleed && "bleed",
      props.listType ? `type-${props.listType}` : (props.ordered ? "type-decimal" : "type-none"),
      props.sortable && "sortable"
    ], props.className)
  }

  const moveListItemHandler = (dragIndex, hoverIndex) => {
    const dragItem = items[dragIndex];

    if (dragItem) {
      setItems((prevState) => {
        const coppiedStateArray = [...prevState];

        // remove item by "hoverIndex" and put "dragItem" instead
        const prevItem = coppiedStateArray.splice(hoverIndex, 1, dragItem);

        // remove item by "dragIndex" and put "prevItem" instead
        coppiedStateArray.splice(dragIndex, 1, prevItem[0]);
        if (props.onSort) {
          props.onSort(coppiedStateArray)
        }
        return coppiedStateArray;
      });
    }
  }

  const renderEach = () => {
    if (Array.isArray(items)) {
      return items.map( (listItem, index) => renderListItem(listItem, `list--${index}`, index))
    } else if (typeof items === "object") {
      let keys = Object.keys(items);
      return keys.map( (key, index) => renderListItem(items[key], key, index))
    }
  }

  const renderListItem = (data, key, index) => {
    if (props.sortable) {
      return (
        <DragItem
          key={key}
          className={bem("list", "item")}
          //deliminater={props.deliminated || null}
          name={data.name}
          setItems={setItems}
          moveHandler={moveListItemHandler}
          placeholder={true}
          type={props.itemType}
        >
          {renderListItemContent(data, key)}
        </DragItem>
      )
    } else {
      return (
        <li key={key} className={bem("list", "item")} deliminater={props.deliminated || null}>
          {renderListItemContent(data, key)}
        </li>
      )
    }
  }

  const renderListItemContent = (data, key) => {
    if (props.render) {
      return props.render(data, key)
    } else if (data) {
      return data.toString()
    }
  }

  let Container = (elProps) => (<ul {...elProps} />)

  if (props.ordered) {
    Container = (elProps) => (<ol {...elProps} />)
  }

  if (props.sortable) {
    return (
      <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
        <DragItem {...p}>
            {renderEach()}
        </DragItem>
        
      </DndProvider>
    )
  } else {
    return (
      <Container {...p}>
        {renderEach()}
      </Container>
    )
  }

}

List.propTypes = {
  className: PropTypes.string,
  listType: PropTypes.string, //css list-style-type property
  bordered: PropTypes.bool,
  rounded: PropTypes.bool,
  shadowed: PropTypes.bool,
  bleed: PropTypes.bool,
  sortable: PropTypes.bool,
  bordered: PropTypes.bool,
  itemType: PropTypes.string,
  deliminated: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  onSort: PropTypes.func
}

List.defaultProps = {
  itemType: "default"
}

export default List




